<script lang="ts">
    import { createEventDispatcher, tick } from "svelte"
    import { navigate } from "svelte-routing"

    import { location, showMobileNav, navigations, currentLang } from "../../store"

    export let entry = null
    export let items = []
    export let layer: number = 0
    export let ident = ""
    export let mobile: boolean = false

    let dispatch = createEventDispatcher()
    $: show = false
    let nav: HTMLElement

    const onClickRouterPath = async (item: NavigationItem) => {
        if (item.settings?.page) {
            navigate(item.settings?.page)
        } else if (item.settings?.url?.url) {
            navigate(item.settings.url.url)
        }

        checkIsActive(item)

        $showMobileNav = false
    }

    const getInternalUrl = (item): string => {
        if (item.settings.page === "/") {
            return item.settings.page
        }

        return item.settings.page
    }

    const onMouseLeave = (e) => {
        if (layer === 0) {
            e.target.classList.remove("show")
            e.target.querySelectorAll(".show").forEach((li) => {
                li.classList.remove("show")
            })
        }
    }

    const onMouseOver = (e, item) => {
        if (item?.settings?.items && item?.settings?.items?.length) {
            e.target.classList.add("show")
        }
    }

    const checkIsActive = (i: NavigationItem) => {
        const result = window.location.pathname.substring(1) === i?.settings?.page

        if (result) {
            onActive()
        }

        return result
    }

    const onActive = () => {
        show = true
        addActiveToParentItem()
        dispatch("active")
    }

    const addActiveToParentItem = () => {
        if (nav) {
            nav.parentElement.classList.add("active")
        }
    }

    $: if (!entry && $navigations) {
        $navigations?.map((nav) => {
            if (nav.ident === ident && nav.locale === $currentLang) {
                entry = nav
                items = nav.items
            }
        })
    }

    $: if (nav && show) addActiveToParentItem()
</script>

{#if items}
    <nav class="{ident} layer-{layer}" class:mobile class:show bind:this="{nav}">
        {#each items || [] as item, index}
            {#if !item?.settings?.url?.hidden}
                {#if item?.settings?.url?.url}
                    {#if item.settings.url.target === "default"}
                        <!-- Svelte Routing -->
                        <a
                            on:click|preventDefault="{() => onClickRouterPath(item)}"
                            on:keydown
                            href="{getInternalUrl(item)}"
                            class="nav-item layer-{layer}"
                            class:active="{() => checkIsActive(item)}"
                            on:mouseover="{(e) => onMouseOver(e, item)}"
                            on:mouseleave="{onMouseLeave}"
                            on:focus
                        >
                            <span>{item.settings.title}</span>
                        </a>
                    {:else}
                        <!-- Standard HTML link-->
                        <a
                            class="nav-item layer-{layer}"
                            class:active="{() => checkIsActive(item)}"
                            href="{item.settings.url.url}"
                            target="{item.settings.url.target}"
                            on:mouseover="{(e) => onMouseOver(e, item)}"
                            on:mouseleave="{onMouseLeave}"
                            on:focus
                        >
                            <span class="nav-item-label">{item.settings.title}</span>
                        </a>
                    {/if}
                {:else}
                    <!-- Next sub navigation -->
                    <div
                        class="nav-item layer-{layer}"
                        class:active="{checkIsActive(item)}"
                        on:mouseover="{(e) => onMouseOver(e, item)}"
                        on:mouseleave="{onMouseLeave}"
                        on:focus
                        on:click|stopPropagation="{() => onClickRouterPath(item)}"
                        on:keydown
                    >
                        <span class="nav-item-label">
                            {item?.settings?.title}
                        </span>

                        {#if item?.settings?.items && item?.settings?.items?.length}
                            <svelte:self
                                entry="{entry}"
                                items="{item?.settings?.items}"
                                layer="{layer + 1}"
                                on:active="{onActive}"
                            />
                        {/if}
                    </div>
                {/if}
            {/if}
        {/each}
    </nav>
{/if}
